<script lang="ts">
    import { Badge } from "sveltestrap";
    import { Box, LayoutType, LTR, RTL } from "../../utils/Constant/Constant";
    import CommenUl from "./CommenUl.svelte";
    import SidebarType from "./SidebarType.svelte";
    let gridClass:string
    const handleGrid = (getClass:string) => {
        gridClass = getClass
        if (getClass === 'rtl') {
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr');
            document.body.classList.remove('box-layout');
            document.documentElement.dir = 'rtl';
        } else if (getClass === 'ltr') {
            document.body.classList.add('ltr');
            document.body.classList.remove('rtl');
            document.body.classList.remove('box-layout');
            document.documentElement.dir = 'ltr';
        } else if (getClass === 'box-layout') {
            document.body.classList.remove('ltr');
            document.body.classList.remove('rtl');
            document.body.classList.add('box-layout');
            document.documentElement.dir = 'ltr';
        }
    }
</script>
<h6>{LayoutType}</h6>
<ul class= 'main-layout layout-grid '>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li on:click={()=>handleGrid("ltr")} class={gridClass === "ltr" ? "active" : ""}>
       <CommenUl/>
        <div class="body">
            <ul>
                <li class= 'bg-light sidebar'></li>
                <li class= 'bg-light body'>
                    <Badge color="primary">{LTR}</Badge>
                </li>
            </ul>
        </div>
    </li>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li on:click={()=>handleGrid("rtl")} class={gridClass === "rtl" ? "active" : ""}>
        <CommenUl/>
        <div class="body">
            <ul>
                <li class= 'bg-light body'>
                    <Badge color="primary">{RTL}</Badge>
                </li>
                <li  class= 'bg-light sidebar'></li>
            </ul>
        </div>
    </li>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li on:click={()=>handleGrid("box-layout")} class={gridClass === "box-layout" ? "active" : ""}>
        <CommenUl/>
        <div class="body">
            <ul>
                <li class= 'bg-light sidebar'></li>
                <li class= 'bg-light body'>
                    <Badge color="primary">{Box}</Badge>
                </li>
            </ul>
        </div>
    </li>
</ul>
<SidebarType />